module.exports = __webpack_public_path__ + "static/media/Mapa_5.d2427057.svg";